// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"9057d594","339":"5260d662","629":"fae13af6"}[chunkId] + ".chunk.js";
};